module.exports = __webpack_public_path__ + "img/CRC1_Mast.30381cd6.png";